export type LoanPurpose = 
  'Purchase Additional Asset' |
  'Replace Existing Asset' |
  'Refinance Existing Borrowing' |
  'Refinance ATO Debt' |
  'Renovations or Relocation of Business Premises' |
  'Pay Invoices, Suppliers or other Regular Expenses' |
  'Purchase of Inventory/Stock' |
  'Purchase of Commercial Property' |
  'Buyout of an Existing Director or Shareholder' |
  'Purchase of Another Business' |
  'Business Expansion/Growth Capital' |
  'Managing Cashflow' |
  'Purchase of Financial Instruments' |
  'Purchase of Residential Property' |
  'Funding Insurance Premium' |
  'Limit Increase' |
  'Limit Decrease' |
  'Renewal';

export const LoanPurposeIds = {
  'Purchase Additional Asset': 1,
  'Replace Existing Asset': 2,
  'Refinance Existing Borrowing': 3,
  'Refinance ATO Debt': 4,
  'Renovations or Relocation of Business Premises': 5,
  'Pay Invoices, Suppliers or other Regular Expenses': 6,
  'Purchase of Inventory/Stock': 7,
  'Purchase of Commercial Property': 8,
  'Buyout of an Existing Director or Shareholder': 9,
  'Purchase of Another Business': 10,
  'Business Expansion/Growth Capital': 11,
  'Managing Cashflow': 12,
  'Purchase of Financial Instruments': 13,
  'Purchase of Residential Property': 14,
  'Funding Insurance Premium': 15,
  'Limit Increase': 16,
  'Limit Decrease': 17,
  'Renewal': 18,
}

export type LoanPurposeOption = {
  id: number,
  name: LoanPurpose,
};

export type LoanPurposeValue = {
  id: number,
  name: LoanPurpose,
  isIncomeGeneratingAsset?: boolean,
  expectedMonthlyIncome?: number,
  hasExistingFinanceCommitments?: boolean,
  lender?: string,
  loanValue?: number,
  taxBalance?: number,
  purchasePrice?: number,
  purposeDescription?: string,
} | null;

export const LoanPurposeValueOptions: LoanPurposeOption[] = [
  {id: LoanPurposeIds['Purchase Additional Asset'] , name: 'Purchase Additional Asset'},
  {id: LoanPurposeIds['Replace Existing Asset'] , name: 'Replace Existing Asset'},
  {id: LoanPurposeIds['Refinance Existing Borrowing'] , name: 'Refinance Existing Borrowing'},
  {id: LoanPurposeIds['Refinance ATO Debt'] , name: 'Refinance ATO Debt'},
  {id: LoanPurposeIds['Renovations or Relocation of Business Premises'] , name: 'Renovations or Relocation of Business Premises'},
  {id: LoanPurposeIds['Pay Invoices, Suppliers or other Regular Expenses'] , name: 'Pay Invoices, Suppliers or other Regular Expenses'},
  {id: LoanPurposeIds['Purchase of Inventory/Stock'] , name: 'Purchase of Inventory/Stock'},
  {id: LoanPurposeIds['Purchase of Commercial Property'] , name: 'Purchase of Commercial Property'},
  {id: LoanPurposeIds['Buyout of an Existing Director or Shareholder'] , name: 'Buyout of an Existing Director or Shareholder'},
  {id: LoanPurposeIds['Purchase of Another Business'] , name: 'Purchase of Another Business'},
  {id: LoanPurposeIds['Business Expansion/Growth Capital'] , name: 'Business Expansion/Growth Capital'},
  {id: LoanPurposeIds['Managing Cashflow'] , name: 'Managing Cashflow'},
  {id: LoanPurposeIds['Purchase of Financial Instruments'] , name: 'Purchase of Financial Instruments'},
  {id: LoanPurposeIds['Purchase of Residential Property'] , name: 'Purchase of Residential Property'},
  {id: LoanPurposeIds['Funding Insurance Premium'] , name: 'Funding Insurance Premium'},
]

export const OverdraftRenewalPurposeOptions: LoanPurposeOption[] = [
  {id: LoanPurposeIds['Limit Increase'] , name: 'Limit Increase'},
  {id: LoanPurposeIds['Limit Decrease'] , name: 'Limit Decrease'},
  {id: LoanPurposeIds['Renewal'] , name: 'Renewal'},
]

export const AllLoanPurposeOptions: LoanPurposeOption[] = [
  ...LoanPurposeValueOptions,
  ...OverdraftRenewalPurposeOptions,
]